<template>
  <span>
    <v-dialog v-model="dialog" width="90%">
      <template v-slot:activator="{ on }">
        <v-btn outlined :icon="!activatorLabel" v-on="on">
          <v-icon :size="iconSize">{{activatorIcon ? activatorIcon:'mdi-calendar-arrow-left'}}</v-icon>
          {{activatorLabel}}
        </v-btn>
      </template>

      <v-card width="100%" class="mx-auto">
        <v-card-title>Choose a calendar from another Course</v-card-title>
        <v-card-subtitle>By changing the course's calendar, all existing schedules and plans will be overrided with the schedule from the source calendar.</v-card-subtitle>
        <v-card-text class="mt-5">
          <v-radio-group v-model="courseState" row>
            <v-radio label="Active Courses" value="active"></v-radio>
            <v-radio label="Future Courses" value="up-coming"></v-radio>
          </v-radio-group>
          <v-select v-model="course" :items="courses" item-value="id" item-text="name" label="Choose a source course"/>

          <schedule-events v-if="events && events.length > 0" :key="course" :events="events" />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn class="ma-5" @click="selectedCalendar">Select Calendar</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const ScheduleEvents = () => import("@/components/course/ScheduleEvents.vue");

export default {
  props: ["activatorIcon", "activatorLabel", "iconSize"],
  data() {
    return {
      dialog: false,
      courses: [],
      course: null,
      events: [],
      courseState: 'up-coming'
    };
  },
  watch: {
    dialog(show) {
      if (show) {
        this.loadCoursesWithActiveSchedules();
      }
    },
    courseState(state){
      console.log('changed state: '+ state)
      this.loadCoursesWithActiveSchedules();
    },
    course(courseId){
      if(courseId){
        this.pullCourseEvents(courseId)
          .then(events => {
            console.log(events);
            this.events = events;
          })
      }
    }
  },
  components:{
    ScheduleEvents
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    loadCoursesWithActiveSchedules() {
      const params = {
        courseState: this.courseState, // available states are 'up-coming', 'active' and 'ended'
        pageSize: 50
      };

      this.$axios
        .get("/course/searchCourse", {params})
        .then(resp => {
          console.log(resp.data)
          const results = resp.data.data.content;
          //Filter out courses that already has an alteranative calendar
          this.courses = results.filter( c => c.alt_google_course_calendar == null );
        })
        .catch(() => {
          this.addErrorMessage("Error loading active courses from server");
        });

    },
    pullCourseEvents(courseId) {
      return new Promise((resolve, reject) => {
        const params = {
          courseId: courseId,
          useActiveCalendar: false,
        };
        this.$axios
          .get("/classroom/course/events", { params })
          .then(resp => {
            resolve(resp.data);
          })
          .catch(err => {
            this.addErrorMessage("Error retrieving calendar events");
            reject(err);
          });
      });
    },
    openDialog(event) {
      this.$emit("onOpen", event);
    },
    selectedCalendar() {

      const selectedCourse = this.courses.find( c => c.id == this.course);
      this.$emit("selectedCalendar", selectedCourse);

      this.dialog = false;
    }
  },
  mounted() {
    this.loadCoursesWithActiveSchedules();
  }
};
</script>

<style>
</style>